export const generalContentDefaultConfiguration = {
  name: 'LAYOUT_02',
  layout: 'LAYOUT_02',
  bannerImageEnabled: true,
  bannerImage: null,
  backgroundImageEnabled: true,
  backgroundColor: '',
  backgroundImage: {
    name: 'image',
    path:
      'https://images.pexels.com/photos/1524105/pexels-photo-1524105.jpeg?cs=srgb&dl=three-women-posing-for-photo-1524105.jpg&fm=jpg',
    uuid: '',
  },
  contentContainerBackgroundColor: '',
  contentContainerOpacity: 10,
  buttonText: 'Next',
  buttonStyle: 'STYLE_1',
  content: '',
};
